import { EServices, IGetBetsPositionResponse } from '../../../../repositories/auction/v1/get-bets-position';
import { IBetPositionByService } from '../../../../redux/reducers/betPosition/types';
import { mapBetPosition } from './mapBetPosition';
import { EServiceId } from '../../../../redux/reducers';

export function mapSuccessResponse(response: IGetBetsPositionResponse): IBetPositionByService {
  const betsByServices = response.betsByServices || {};

  return Object.entries(betsByServices).reduce((acc, [service, betPosition]) => {
    if (!betPosition) {
      return acc;
    }

    const mappedBetPosition = mapBetPosition(betPosition);

    switch (service) {
      case EServices.Top3:
        acc[EServiceId.top] = mappedBetPosition;

        break;

      case EServices.Premium:
        acc[EServiceId.premium] = mappedBetPosition;

        break;

      case EServices.Paid:
        acc[EServiceId.paid] = mappedBetPosition;

        break;

      case EServices.Free:
        acc[EServiceId.free] = mappedBetPosition;

        break;
    }

    return acc;
  }, {} as IBetPositionByService);
}
